import PushNotificationService from '@/mobile/push-notification.service';
import { isNativeApp } from '@/helpers/platform-helper';
import { logger } from '@/helpers/log.service';

if (isNativeApp()) {
  logger.debug('[cordova.ts] deviceready listener added');
  document.addEventListener('deviceready', onDeviceReady, false);
}

async function onDeviceReady() {
  logger.debug('[cordova.ts] cordova fully loaded', window);

  const pushNotificationAvailable = PushNotificationService.isAvailable();
  logger.debug(`[cordova.ts] pushNotificationAvailable=${pushNotificationAvailable}`);
  if (pushNotificationAvailable) {
    await PushNotificationService.init();
  }
}
